import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import paymentActions from '../payment/paymentActions';
import userActions from './userActions';

import { Page, PageContent, PageHeader, Tabs } from '../components/common';
import InvoiceDetails from '../payment/InvoiceDetails';
import PaymentHistoryList from '../payment/PaymentHistoryList';
import UpdatePaymentDetails from '../payment/UpdatePaymentDetails';
import { SecurityRoles } from '../common/utils';
import { ensureUserHasRole } from '../auth/authComponents';

interface Props {
	className?: string;
	customer: UserDetails;
	payments: PaymentHistory[];
	actions: any;
	history: any;
	match: any;
}
class TransactionsPage extends React.Component<Props, any> {
	componentDidMount() {
		this.props.actions
			.fetchUser(this.props.match.params.userId)
			.then(() => this.props.actions.fetchCustomerPayments(this.props.match.params.userId));
	}

	getTab = (tabParam: string) => {
		let tab = null;
		if (tabParam === 'payment-info') {
			tab = UpdatePaymentDetails;
		} else if (tabParam === 'view-bills' && this.props.match.params.invoiceNumber) {
			tab = InvoiceDetails;
		} else {
			tab = PaymentHistoryList;
		}

		return tab;
	}

	render() {
		const { className, ...props } = this.props;
		const Tab = this.getTab(this.props.match.params.tab);
		return (
			<Page>
				<PageContent>
					<PageHeader title="Billing" />
					<Tabs
						className="no-print"
						tabs={[
							{
								label: 'Your bills',
								to: `/user/${this.props.match.params.userId}/billing/view-bills`
							},
							{
								label: 'Update your payment info',
								to: `/user/${this.props.match.params.userId}/billing/payment-info`
							}
						]}
						match={this.props.match}
					/>
					<Tab className="tab-content" {...props} />
				</PageContent>
			</Page>
		);
	}
}
function mapStateToProps(state: any) {
	return {
		payments: state.payment.payments,
		customer: state.user.user
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...paymentActions, ...userActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
const ConnectedPage = connect(mapStateToProps, mapDispatchToProps)(TransactionsPage);
export default ensureUserHasRole(ConnectedPage as any, [SecurityRoles.Customer]);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/user/TransactionsPage.tsx